<app-header></app-header>
<div class="main-result">
    <div class="container">
        <div class="row">
            <div class="col-md-6 result-box">
                <div>
                    <h1>{{data.result?data.result.fk_number_id:'--'}}</h1>
                    <h4>Diamond Win</h4>
                    <p>Next Result : <span id="countdown">00:00:00</span></p>
                </div>
            </div>
            <div class="col-md-6 result-box">
                <div>
                    <h1>{{data.matka_latest?(data.matka_latest.number<10?data.matka_latest.number:data.matka_latest.number):"--"}}</h1>
                    <h4>{{data.matka_latest && data.matka_latest.game?data.matka_latest.game.name.name:'--'}}</h4>
                    <p>Result Time : {{data.matka_latest && data.matka_latest.game?data.matka_latest.game.result_time:'--'}}</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <div class="ads">
        <p>घर बैठे कमाइए<br>अभी आप घर बैठकर ऑनलाइन सट्टा खेलकर कमा सकते हैं अब आपको कहीं जाने की जरूरत नहीं है आपके ही मोबाइल में हम आपके लिए लाए हैं ऑनलाइन सट्टा है इसे ज्वाइन करने के लिए नीचे दिए गए डाउनलोड बटन पर क्लिक करे </p>
        <a target="_blank" href="http://api.jantarmantar.club/1x90.apk">Download Now</a>
    </div>
</div>

<div class="result-chart">
    <div class="container">
        <div class="row">
            <div class="col-md-3 result-chart-box" *ngFor="let i of data.matka_game">
                <p [ngStyle]="{'background-color':i.color}">{{i.name.name}}</p>
                <div class="row result-row">
                    <div class="col">
                        Today Result
                    </div>
                    <div class="col text-right">
                        {{i.result?i.result.number:'--'}}
                    </div>
                </div>
                <div class="row result-row">
                    <div class="col">
                        Last Result
                    </div>
                    <div class="col text-right">
                        {{i.yesterday?i.yesterday.number:'--'}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="container">
    <div class="ads">
        <p>घर बैठे कमाइए<br>अभी आप घर बैठकर ऑनलाइन सट्टा खेलकर कमा सकते हैं अब आपको कहीं जाने की जरूरत नहीं है आपके ही मोबाइल में हम आपके लिए लाए हैं ऑनलाइन सट्टा है इसे ज्वाइन करने के लिए नीचे दिए गए डाउनलोड बटन पर क्लिक करे </p>
        <a target="_blank" href="http://api.jantarmantar.club/1x90.apk">Download Now</a>
    </div>
</div>

<section class="monthchart">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h3>Current Month Chart</h3>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-hover table-dark ">
                <tr>
                    <th>Date</th>
                    <th *ngFor="let i of data.chart.game;let index=index" class="text-center">
                        <p>{{i.name.short_name}}</p>
                        <!-- <small>{{i.name.name}}</small> -->
                    </th>
                </tr>
                <tr *ngFor="let i of data.chart.array">
                    <td>{{i.date}}</td>
                    <td  class="text-center" *ngFor="let j of i.games">{{j.result?(j.result.fk_number_id<10?'0'+j.result.fk_number_id:j.result.fk_number_id):'--'}}</td>
                </tr>
            </table>
        </div>
    </div>
</section>

<div class="section">
    <div class="container-fluid">
        
<div class="download_pod pof">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए Lottory Color एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get Lottory Color App</p>
                <a target="_blank" href="https://lottorycolor.com/" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/lottorycolor.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 


<div class="download_pod blue">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए Play Online Gali एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get Play Online Gali (POG) App</p>
                <a href="../../../assets/apk/pog.apk" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/pog.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 

<div class="download_pod red">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए Play Online Delhi एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get Play Online Delhi (POD) App</p>
                <a href="../../../assets/apk/pod.apk" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/rapidjpg.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 


<div class="download_pod yellow">
    <div class="row">
        <div class="col-md-6">
            <p>रियल कॅश के साथ लूडो गेम खेलने के लिए PODLUDO Game डाउनलोड करे | डाउनलोड करने के लिए डाउनलोड पर क्लिक करे
            </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get PODLUDO App</p>
                <a href="https://podludo.com" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/podludo.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 


<div class="download_pod gray">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए PODBET51 एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get PODBET51 App</p>
                <a href="https://play.google.com/store/apps/details?id=com.podbet51" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/podbet51.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 
<!-- 

<div class="download_pod green">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए SG Company एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get SG Company App</p>
                <a href="../../../assets/apk/sgcompany.apk" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/sg.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div> 


<div class="download_pod yellow">
    <div class="row">
        <div class="col-md-6">
            <p>गेम खेलने के लिए MG Company एप्लीकेशन डाउनलोड करे डाउनलोड करने के लिए डाउनलोड पर क्लिक करे </p>
        </div>
        <div class="col-md-6 align-middle">
            <div class="download_now">
                <p>Get MG Company App</p>
                <a href="../../../assets/apk/mgcompany.apk" class="btn btn-outline-light button download">
                    <img src="../../../assets/images/mg.png" class="img-fluid"/> <span>Download Now</span>
                </a>
            </div>
        </div>
    </div>
</div>  -->

    </div>
</div>

<div class="pops" *ngIf="showDeep">

    <div class="firework"></div>
    <div class="firework"></div>
    <div class="firework"></div>
</div>

<app-footer></app-footer>